import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import styled from "styled-components";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Top from "./components/Top";
import Bottom from "./components/Bottom";
import Main from "./pages/main";
import Address from "./pages/address";
import Price from "./pages/price";
import Fin from "./pages/fin";
import Info from "./pages/info/info";

import NotFound from "./pages/404Page";


import DriverIndex from "./pages/driveloc/index";
import Content01 from "./pages/driveloc/content01";
import Content02 from "./pages/driveloc/content02";
import Content03 from "./pages/driveloc/content03";
import Content04 from "./pages/driveloc/content04";

// import Content01 from "./components/Content01";
// import Content02 from "./components/Content02";
// import Content03 from "./components/Content03";
// import Content04 from "./components/Content04";

const AppFrame = styled.div`
  padding: 80px 0px;
  width: 1100px;
  min-height: 100vh;
  background-color: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  @media (max-width: 1099px) {
    width: 100%;
    padding: 36px 20px;
  }
`;

const ButtonLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 60px 0 80px 0;
  @media (max-width: 1099px) {
    gap: 10px;
    padding: 36px 0;
  }
`;

const ButtonRed = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eb3f3d;
  color: #fff;
  font-family: Gongim-Medium;
  font-size: 20px;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

const ButtonBack = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #707070;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  color: #707070;
  font-family: Gongim-Medium;
  font-size: 20px;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

function App() {
  const [State01, setState01] = useState(true);
  const [State02, setState02] = useState(false);
  const [State03, setState03] = useState(false);
  const [State04, setState04] = useState(false);

  console.log(process.env.NODE_ENV)

  const nextState = () => {
    if (State01 === true) {
      setState01(false);
      setState02(true);
    } else if (State02 === true) {
      setState02(false);
      setState03(true);
    } else if (State03 === true) {
      setState03(false);
      setState04(true);
    } else if (State04 === true) {
      window.open("https://www.gongim.com/main/main.php", "mozillaTab");
    }
  };

  const pretState = () => {
    if (State02 === true) {
      setState01(true);
      setState02(false);
    } else if (State03 === true) {
      setState02(true);
      setState03(false);
    }
  };

  return (
    <BrowserRouter>
      <div className="App">
        <AppFrame>
          <Top />
            <Routes>
              <Route path="/info" element={<Info />} />
              <Route path="/" element={<Main />} />
              <Route path="/address" element={<Address />} />
              <Route path="/Price" element={<Price />} />
              <Route path="/Fin" element={<Fin />} />
              <Route path="/driveloc/:orderNo" element={<DriverIndex />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          <Bottom />
        </AppFrame>
        {/* <AppFrame>
          <Top
            State01={State01}
            State02={State02}
            State03={State03}
            State04={State04}
          />
          {State01 && <Content01 req={payload} />}
          {State02 && <Content02 />}
          {State03 && <Content03 />}
          {State04 && <Content04 />}

          {State01 && (
            <ButtonLine>
              <ButtonBack onClick={pretState}>취소</ButtonBack>
              <ButtonRed onClick={nextState}>다음</ButtonRed>
            </ButtonLine>
          )}

          {State02 && (
            <ButtonLine>
              <ButtonBack onClick={pretState}>이전</ButtonBack>
              <ButtonRed onClick={nextState}>다음</ButtonRed>
            </ButtonLine>
          )}

          {State03 && (
            <ButtonLine>
              <ButtonBack onClick={pretState}>이전</ButtonBack>
              <ButtonRed onClick={nextState}>다음</ButtonRed>
            </ButtonLine>
          )}
          {State04 && (
            <ButtonLine>
              <ButtonRed onClick={nextState}>확인</ButtonRed>
            </ButtonLine>
          )}
          <Bottom />
          {State01 && <>1</>}
          {State02 && <>2</>}
          {State03 && <>3</>}
          {State04 && <>4</>}
        </AppFrame> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
